import {UserEffects} from "./entities/uaa/user/user.effects";
import {StoreItemEffects} from "./entities/store-item/store-item.effects";
import { InstitutionEffects } from "./entities/uaa/institution/institution.effects";


export const effects = [
  StoreItemEffects,
  UserEffects,
  InstitutionEffects,
];
